import { Stack, Typography } from '@mui/material';

export function WeekColumnHeader({
  weekLabel,
  dateRange
}: {
  weekLabel: string;
  dateRange: string;
}) {
  return (
    <Stack alignItems="center" spacing={0}>
      <Typography variant="caption" sx={{ lineHeight: 1.3 }}>
        {weekLabel}
      </Typography>
      <Typography
        variant="caption"
        sx={{ fontSize: '0.65rem', lineHeight: 1.2, color: 'text.secondary' }}
      >
        {dateRange}
      </Typography>
    </Stack>
  );
}
